export var ApplyPolicy;
(function (ApplyPolicy) {
    ApplyPolicy["AfterResolver"] = "AFTER_RESOLVER";
    ApplyPolicy["BeforeResolver"] = "BEFORE_RESOLVER";
    ApplyPolicy["Validation"] = "VALIDATION";
})(ApplyPolicy || (ApplyPolicy = {}));
export var AuditLogTypeEnum;
(function (AuditLogTypeEnum) {
    AuditLogTypeEnum["TrackAttendance"] = "TRACK_ATTENDANCE";
    AuditLogTypeEnum["Unknown"] = "UNKNOWN";
})(AuditLogTypeEnum || (AuditLogTypeEnum = {}));
export var FileTypeEnum;
(function (FileTypeEnum) {
    FileTypeEnum["AttendancePdf"] = "ATTENDANCE_PDF";
    FileTypeEnum["CalendarEventType"] = "CALENDAR_EVENT_TYPE";
    FileTypeEnum["CareGiver"] = "CARE_GIVER";
    FileTypeEnum["Child"] = "CHILD";
    FileTypeEnum["ChildBirthCertificate"] = "CHILD_BIRTH_CERTIFICATE";
    FileTypeEnum["ChildClinicCard"] = "CHILD_CLINIC_CARD";
    FileTypeEnum["ChildRegistrationForm"] = "CHILD_REGISTRATION_FORM";
    FileTypeEnum["ClassroomProfile"] = "CLASSROOM_PROFILE";
    FileTypeEnum["ClubActivityUpload"] = "CLUB_ACTIVITY_UPLOAD";
    FileTypeEnum["Coach"] = "COACH";
    FileTypeEnum["ContentImage"] = "CONTENT_IMAGE";
    FileTypeEnum["IdentityDocument"] = "IDENTITY_DOCUMENT";
    FileTypeEnum["IncomeStatementPdf"] = "INCOME_STATEMENT_PDF";
    FileTypeEnum["MaternalCaseRecord"] = "MATERNAL_CASE_RECORD";
    FileTypeEnum["Practitioner"] = "PRACTITIONER";
    FileTypeEnum["PractitionerAgreement"] = "PRACTITIONER_AGREEMENT";
    FileTypeEnum["ProfileImage"] = "PROFILE_IMAGE";
    FileTypeEnum["ProgressTrackingCategory"] = "PROGRESS_TRACKING_CATEGORY";
    FileTypeEnum["ProgressTrackingLevel"] = "PROGRESS_TRACKING_LEVEL";
    FileTypeEnum["ProgressTrackingSubCategory"] = "PROGRESS_TRACKING_SUB_CATEGORY";
    FileTypeEnum["ProofOfAccount"] = "PROOF_OF_ACCOUNT";
    FileTypeEnum["ProofOfSiteAddress"] = "PROOF_OF_SITE_ADDRESS";
    FileTypeEnum["Reports"] = "REPORTS";
    FileTypeEnum["ReportTemplates"] = "REPORT_TEMPLATES";
    FileTypeEnum["RoadToHealthBook"] = "ROAD_TO_HEALTH_BOOK";
    FileTypeEnum["StartupSupportAgreement"] = "STARTUP_SUPPORT_AGREEMENT";
    FileTypeEnum["Theme"] = "THEME";
    FileTypeEnum["Unknown"] = "UNKNOWN";
})(FileTypeEnum || (FileTypeEnum = {}));
export var GraphActionEnum;
(function (GraphActionEnum) {
    GraphActionEnum["Create"] = "CREATE";
    GraphActionEnum["Delete"] = "DELETE";
    GraphActionEnum["Update"] = "UPDATE";
    GraphActionEnum["View"] = "VIEW";
})(GraphActionEnum || (GraphActionEnum = {}));
export var InputFilterComparer;
(function (InputFilterComparer) {
    InputFilterComparer["ContainedBy"] = "CONTAINED_BY";
    InputFilterComparer["Contains"] = "CONTAINS";
    InputFilterComparer["Equals"] = "EQUALS";
    InputFilterComparer["GreaterThan"] = "GREATER_THAN";
    InputFilterComparer["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
    InputFilterComparer["ILike"] = "I_LIKE";
    InputFilterComparer["LessThan"] = "LESS_THAN";
    InputFilterComparer["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
})(InputFilterComparer || (InputFilterComparer = {}));
export var SortEnumType;
(function (SortEnumType) {
    SortEnumType["Asc"] = "ASC";
    SortEnumType["Desc"] = "DESC";
})(SortEnumType || (SortEnumType = {}));
export var TenantType;
(function (TenantType) {
    TenantType["ChwConnect"] = "CHW_CONNECT";
    TenantType["Host"] = "HOST";
    TenantType["OpenAccess"] = "OPEN_ACCESS";
    TenantType["WhiteLabel"] = "WHITE_LABEL";
    TenantType["WhiteLabelTemplate"] = "WHITE_LABEL_TEMPLATE";
})(TenantType || (TenantType = {}));
export var WorkflowStatusEnum;
(function (WorkflowStatusEnum) {
    WorkflowStatusEnum["ChildActive"] = "CHILD_ACTIVE";
    WorkflowStatusEnum["ChildDeactivated"] = "CHILD_DEACTIVATED";
    WorkflowStatusEnum["ChildExternalLink"] = "CHILD_EXTERNAL_LINK";
    WorkflowStatusEnum["ChildPending"] = "CHILD_PENDING";
    WorkflowStatusEnum["DocumentDeclared"] = "DOCUMENT_DECLARED";
    WorkflowStatusEnum["DocumentPendingUpload"] = "DOCUMENT_PENDING_UPLOAD";
    WorkflowStatusEnum["DocumentPendingVerification"] = "DOCUMENT_PENDING_VERIFICATION";
    WorkflowStatusEnum["DocumentVerified"] = "DOCUMENT_VERIFIED";
})(WorkflowStatusEnum || (WorkflowStatusEnum = {}));
//# sourceMappingURL=generatedGraphql.js.map